import { useId, useRef } from 'react';
import { cn } from '@/lib/cn';
import { Input } from '@/components/ui/Input';
import { useT } from '@/lib/i18n/useT';

interface ColorFieldProps {
  value: string;
  onChange: (next: string) => void;
  label?: string;
  className?: string;
}

export function ColorField({ value, onChange, label, className }: ColorFieldProps) {
  const t = useT();
  const id = useId();
  const colorRef = useRef<HTMLInputElement>(null);
  const valid = /^#[0-9a-fA-F]{6}$/.test(value);

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <label
          htmlFor={id}
          className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]"
        >
          {label}
        </label>
      )}
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label={t('forms.colorField.pickColor')}
          onClick={() => colorRef.current?.click()}
          className="h-10 w-10 shrink-0 rounded-lg border border-[var(--color-border-default)] cursor-pointer"
          style={{ backgroundColor: valid ? value : 'transparent' }}
        />
        <input
          ref={colorRef}
          type="color"
          value={valid ? value : '#000000'}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          className="sr-only"
        />
        <Input
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#B262F5"
          invalid={!valid && value.length > 0}
          className="font-mono uppercase"
        />
      </div>
    </div>
  );
}
